export const css = {
    root: 'IP4rt3XU',
    scoreContainer: '_3DHTa0PM',
    title: '_2rbnkV22',
    wrapper: 'mY1nSNTq',
    domain: 'W6H-3ty1',
    field: '_2fhHtHrZ',
    bar: 'ZGxwMxUs',
    lowScore: '_2cL2pKQ-',
    midScore: '_2ONcAiWg',
    highScore: '_1cOajn1H',
    barZero: '_7RvfdWFw',
    barLow: 'jYtLY7_6',
    barMid: '_1VonXyE5',
    barHigh: '_3LP8c3pD',
    barscore: '_7ZZBDgMX',
    legend: '_1jYFyuHa',
    ' _key': 'afcpe-theme/afcpe/prepost-viz/progress-viz'
};
export default css;
